import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { get_agency_details } from '../../api/API';

import DetailData from '../../pages/DetailAgency/components/DetailData';

const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
}));

export default class DetailAgency extends React.Component {
    
    constructor(props){
        super(props);
        // console.log( this.props.match );

        this.state = {
            agencys: null,
            agency_id: props.agency_id
        }
    }
  
    async get_data(){
        const postparam = {
            agency_id: this.state.agency_id
        }; 
       
        var json = await get_agency_details(postparam);
        if(json.status){
            console.log(json);
            this.setState({...this.state, agencys : json.data });
        }
    }
 
    componentDidMount(){
        this.get_data();
    }

    refresh(){
        this.get_data();
    }

    render(){
        return (
            <Grid
                {...this.props}
                className={clsx(this.props.classes.root, this.props.className)}
                container
                spacing={3}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={4}
                    xs={12}
                >
                { this.state.agencys ? 
                <DetailData 
                refresh={this.refresh.bind(this)}
                {...this.props}
                classes={this.props.classes} agencys={this.state.agencys} /> : ''
                }
                </Grid>
                
            </Grid>
        )
    }
}




